<div bsModal #existingContactTemplate="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xxl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Matching Contact Information</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeExistingModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>There are matching Customer records. Confirm if it is an Existing Customer?</p>
        @if (!isQuickStart) {
          <div>
            <app-call-script [section]="section" [isScreenPopup]="isScreenPopup"></app-call-script>
          </div>
        }
        <div class="scroll_outer">
          <div class="scroll_inner_small">
            <div class="borderd_table">
              <table class="table table-striped table-hover">
                <thead>
                  <tr>
                    <th width="10">
                    </th>
                    <th width="10" class="text-left">First Name</th>
                    <th width="10" class="text-left">Last Name</th>
                    <th width="10" class="text-left">Phone</th>
                    <th width="10" class="text-left" style="width: 160px;">E-mail</th>
                    <th width="20" class="text-left">Address</th>
                    <th width="10" class="text-left">Prospect Type</th>
                    <th width="10" class="text-left">Unit Selection</th>
                    <th width="10" class="text-left">Do not Rent</th>
                  </tr>
                </thead>
                @for (item of existingContactList; track item) {
                  <tbody>
                    @for (listItem of item.ProspectItems; track listItem; let i = $index) {
                      <tr class="clickable" data-bs-toggle="collapse" data-bs-target="#group-of-rows-1"
                        aria-expanded="false"
                        (click)="getExistingContact($event, listItem)"
                        [ngClass]="getRowClass(i, listItem.TenantId)" aria-controls="group-of-rows-1">
                        @if (i == 0) {
                          <td [attr.rowspan]="item.ProspectItems.length">
                            @if (i == 0 && item.ProspectItems.length > 1 ) {
                              <div [ngClass]="getRowClass(i, listItem.TenantId)"
                                #openCloseButton
                                (click)="toggleButton($event, listItem.TenantId)"
                                class="add_prospect_list">
                              &nbsp;</div>
                            }
                          </td>
                        }
                        @if (i == 0) {
                          <td class="text-left" [attr.rowspan]="item.ProspectItems.length">
                          {{listItem.FirstName}}</td>
                        }
                        @if (i == 0) {
                          <td class="text-left" [attr.rowspan]="item.ProspectItems.length">
                          {{listItem.LastName}}</td>
                        }
                        @if (i == 0) {
                          <td class="text-left" [attr.rowspan]="item.ProspectItems.length">
                          {{listItem.AllPhoneNumbers}}</td>
                        }
                        @if (i == 0) {
                          <td class="text-left break-custom" [attr.rowspan]="item.ProspectItems.length">
                          {{listItem.EmailId}}</td>
                        }
                        @if (i == 0) {
                          <td class="text-left" [attr.rowspan]="item.ProspectItems.length">
                          {{listItem.CompleteAddress}}</td>
                        }
                        <td class="text-left"> {{listItem.ProspectType}}</td>
                        <td class="text-left"> {{listItem.UnitSelection}}</td>
                        <td (mouseenter)="hoveredItem = listItem"
                          (mouseleave)="hoveredItem = null">
                          <input type="checkbox" [checked]="listItem.BlackListed" disabled>
                          @if (
                          hoveredItem === listItem &&
                          listItem.BlackListed &&
                          listItem.DoNotRentReason?.trim()
                          ) {
                          <div class="custom-tooltip">
                            {{ listItem.DoNotRentReason }}
                            <span class="tooltip-arrow"></span>
                          </div>
                          }
                        </td>
                      </tr>
                    }
                  </tbody>
                }
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-outline-primary me-3" type="button" (click)="cancelExistingTenant(0)">Create New</button>
      </div>
    </div>
  </div>
</div>
